import store from '~/store'

export default async (to, from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    try {
      await store.dispatch('auth/fetchUser')

      if (!store.getters['questions/questions'].length > 0) {
        store.dispatch('questions/fetchAllQuestions')
        store.dispatch('modules/fetchAllModules')
        store.dispatch('accessories/fetchAccessories')
        store.dispatch('doors/fetchAllDoors')
      }

      next()
    } catch (e) { }
  } else if (!store.getters['auth/check']) {
    next({ name: 'login' })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/auth.js